<template>
    <el-form ref="form" label-position="top" v-loading="getScreenSize < 2 && !delayedLoading[6]"  element-loading-text="Loading...">
        <el-row>
            <el-dialog
                title="New group"
                :visible.sync="newGroup"
                size="tiny"
                >
                <span>{{$l('settings/alertMessaging/createGroupDialog')}} </span>
                <span slot="footer" class="dialog-footer">
                        <el-button @click="newGroup =  false"> {{$l('settings/alertMessaging/dialogCancel')}} </el-button>
                        <el-button type="primary" @click="newGroup =  false; addGroup()"> {{$l('settings/alertMessaging/dialogConfirm')}} </el-button>
                </span>
            </el-dialog>

            <!-- Delete group -->
            <el-dialog
                :visible.sync="dialogVisible"
                size="tiny"
                >
                <span> {{$l('settings/alertMessaging/deleteGroupDialog')}} {{deleteGroup.replace('gr','')}}</span>
                <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible =  false"> {{$l('settings/alertMessaging/dialogCancel')}}  </el-button>
                        <el-button type="primary" @click="dialogVisible =  false; removeGroup(deleteGroup)"> {{$l('settings/alertMessaging/dialogConfirm')}}  </el-button>
                </span>
            </el-dialog>
            <!-- Delete Email, MSISDN -->
            <el-dialog
                title="Tips"
                :visible.sync="dialogVisible1"
                size="tiny"
                >
                <span> {{$l('settings/alertMessaging/deleteEmailDialog')}}</span>
                <span slot="footer" class="dialog-footer">
                        <el-button @click="dialogVisible1 =  false"> {{$l('settings/alertMessaging/dialogCancel')}}  </el-button>
                        <el-button type="primary" @click="dialogVisible1 =  false, deleteRecipient(deleteRecipientGroup)"> {{$l('settings/alertMessaging/dialogConfirm')}}  </el-button>
                </span>
            </el-dialog>

            <!-- Add email dialog -->
            
                            
            <el-form-item class="el-form-item-full" v-if="getScreenSize > 1 || delayedLoading[1]">
                <el-button @click="newGroup = true">{{$l('settings/alertMessaging/createGroupButton')}}</el-button>
            </el-form-item>
            <el-row :gutter="25" v-if="getScreenSize > 1 || delayedLoading[2]">
                <el-col :lg="24" :md="24" :sm="24">
                    <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/MSISDN-E-Mail')">
                        <el-select v-model="selectedGroups" multiple :placeholder="$l('common/select')">
                            <el-option
                                v-for="item in getSettingsAlertMessaging.groups"
                                :key="item"
                                :label="'Group '+item.replace('gr','')"
                                :value="item">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="10" :md="9" :sm="9">
                    <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Add MSISDN')">
                        <el-input v-model="selectedNumber" style="width: 90%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="10" :md="9" :sm="9">
                    <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Add E-mail')">
                        <el-input v-model="selectedEmail" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="2" :md="5" :sm="5">
                    <el-form-item class="el-form-item-full" label = " ">
                        <el-button @click="addRecipientClicked" class="AddEmailButton" size="small" type="danger" icon="plus"> <b>{{$l('settings/addButt')}}</b></el-button>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-collapse accordion v-if="getScreenSize > 1 || delayedLoading[3]">
                <el-collapse-item v-if="getScreenSize > 1 || delayedLoading[4]"  v-for="(group,index) in getSettingsAlertMessaging.groups" v-bind:key="index" :title="'Group ' + (group.replace('gr',''))">
                    
                    <el-row :gutter="25" >
                        <el-col :sm="5" :md="3">
                            <el-button :title="$l('settings/alertMessaging/DeleteGroup')" @click="dialogVisible = true; deleteGroup = group" size="mini" type="danger" class="buttons" icon="delete">{{$l('settings/alertMessaging/DeleteGroup')}} </el-button>
                        </el-col>
                        <el-col :sm="3" :md="3">
                            <el-button :title="$l('settings/alertMessaging/TestEmail')" @click="sendTestMail(group)" size="mini" type="success" class="buttons" icon="share">{{$l('settings/alertMessaging/TestEmail')}}</el-button>
                        </el-col>
                        <el-col :sm="19" :md="19">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/DeleteRecip')">
                                <el-select v-model="getSettingsAlertMessaging['del'+group.replace('gr','')]" :placeholder="$l('common/select')">
                                    <el-option 
                                        v-for="item in getSettingsAlertMessaging['recpg'+group.replace('gr','')]" 
                                        :key="item"
                                        :label="item"
                                        :value="item">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="5" :md="5" :sm="5">
                            <el-form-item class="el-form-item-full" label = " ">
                                <el-button @click="dialogVisible1 = true; deleteRecipientGroup = group" class="DeleteEmailButton" size="small" type="danger" icon="plus"> <b>{{$l('settings/alertMessaging/DeleteButton')}}</b></el-button>
                            </el-form-item>
                        </el-col>
                        
                        <el-col :lg="12" :sm="24">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Threshold day')">
                                <el-row>
                                    <el-col :md="6">
                                        <el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshday']"></el-switch>
                                    </el-col>
                                    <el-col :md="18">
                                        <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][0]" :placeholder="$l('common/select')">
                                            <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                            <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                            <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                            <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                            <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                            <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :sm="24">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Threshold Night')">
                                <el-row>
                                    <el-col :md="6">
                                        <el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshnight']"></el-switch>
                                    </el-col>
                                    <el-col :md="18">
                                        <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][1]" :placeholder="$l('common/select')">
                                            <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                            <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                            <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                            <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                            <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                            <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :sm="24">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Threshold Opt 1')">
                                <el-row>
                                    <el-col :md="6">
                                        <el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshopt1']"></el-switch>
                                    </el-col>
                                    <el-col :md="18">
                                        <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][2]" :placeholder="$l('common/select')">
                                            <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                            <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                            <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                            <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                            <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                            <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :sm="24">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Threshold Opt 2')">
                                <el-row>
                                    <el-col :md="6">
                                        <el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['threshopt2']"></el-switch>
                                    </el-col>
                                    <el-col :md="18">
                                            <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][3]" :placeholder="$l('common/select')">
                                                <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                                <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                                <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                                <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                                <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                                <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                            </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                        <el-col :lg="12" :sm="24">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Running Average Level')">
                                <el-row>
                                    <el-col :md="6">
                                        <el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['mav']"></el-switch>
                                    </el-col>
                                    <el-col :md="18">
                                        <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][4]" :placeholder="$l('common/select')">
                                            <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                            <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                            <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                            <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                            <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                            <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                         <el-col :lg="12" :sm="24">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Weather trigger')">
                                <el-row>
                                    <el-col :md="6">
                                        <el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['weatTrig']"></el-switch>
                                    </el-col>
                                    <el-col :md="18">
                                        <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][5]" :placeholder="$l('common/select')">
                                            <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                            <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                            <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                            <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                            <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                            <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/System reboot')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['reboot']"></el-switch></el-form-item></el-col>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Critical disk space')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['discerr']"></el-switch></el-form-item></el-col>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Connection with meter lost')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['n140']"></el-switch></el-form-item></el-col>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Critical memory on meter')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['n140sd']"></el-switch></el-form-item></el-col>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Microphone check error')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['micerr']"></el-switch></el-form-item></el-col>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/FTP server error')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['ftperr']"></el-switch></el-form-item></el-col>                    
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Battery mode')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['battmode']"></el-switch></el-form-item></el-col>
                        <el-col :lg="12"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Connection with Weather station lost')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['weather']"></el-switch></el-form-item></el-col>
                    </el-row>
                    <el-row>
                        <el-col :lg="4">
                            <el-col :lg="24"><el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/LEQ')"><el-switch on-text="" off-text="" v-model="getSettingsAlertMessaging['alg'+group.replace('gr','')]['leqday']"></el-switch></el-form-item></el-col>
                        </el-col>
                        <el-col :lg="20">
                            <div class="LEQContainer" v-if="getSettingsAlertMessaging['alg'+group.replace('gr','')]['leqday']">
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/resendAft')">
                                            <el-select v-model="getSettingsAlertMessaging['repg'+group.replace('gr','')][6]" :placeholder="$l('common/select')">
                                                <el-option :label="$l('settings/alertMessaging/noRepeat')" value="0"></el-option>
                                                <el-option :label="'1 ' + $l('settings/alertMessaging/min')" value="1"></el-option>
                                                <el-option :label="'5 ' + $l('settings/alertMessaging/min')" value="5"></el-option>
                                                <el-option :label="'10 ' + $l('settings/alertMessaging/min')" value="10"></el-option>
                                                <el-option :label="'15 ' + $l('settings/alertMessaging/min')" value="15"></el-option>
                                                <el-option :label="'30 ' + $l('settings/alertMessaging/min')" value="30"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="16">
                                        <el-row type="flex" justify="space-between" :gutter="25">
                                            <el-col :span="8">
                                                <el-form-item class="el-form-item-full" :label="$l('settings/preTrigg')"> 
                                                    <el-row>
                                                        <el-col :span="4"><el-checkbox v-model="getSettingsAlertMessaging['lqtg'+group.replace('gr','')][0]"></el-checkbox></el-col>
                                                        <el-col :span="20">
                                                            <el-input  v-model="getSettingsAlertMessaging['leqdg'+group.replace('gr','')][0]" style="width: 100%;">
                                                                <template slot="prepend">-</template>
                                                            </el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item class="el-form-item-full" :label="$l('settings/Trigg')"> 
                                                    <el-row>
                                                         <el-col :span="4"><el-checkbox v-model="getSettingsAlertMessaging['lqtg'+group.replace('gr','')][1]"></el-checkbox></el-col>
                                                         <el-col :span="20">
                                                            <el-input disabled :value="getSettingsSpecval.leqdayval"> </el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>                            
                                            </el-col>
                                            <el-col :span="8">
                                                <el-form-item class="el-form-item-full" :label="$l('settings/postTrigg')"> 
                                                    <el-row>
                                                         <el-col :span="4"><el-checkbox v-model="getSettingsAlertMessaging['lqtg'+group.replace('gr','')][2]"></el-checkbox></el-col>
                                                         <el-col :span="20">
                                                            <el-input v-model="getSettingsAlertMessaging['leqdg'+group.replace('gr','')][1]" style="width: 100%;">
                                                                <template slot="prepend">+</template>
                                                            </el-input>
                                                        </el-col>
                                                    </el-row>
                                                </el-form-item>                            
                                            </el-col>
                                        </el-row>
                                    </el-col>
                                </el-row>
                                
                            </div>
                        </el-col>
                    </el-row>
                </el-collapse-item>

                <el-collapse-item v-if="getScreenSize > 1 || delayedLoading[5]" :title="$l('settings/alertMessaging/Inbound (MSISDN)')">
                    <el-row :gutter="25">
                        <el-col :md="24">
                            <div class="Container">{{$l('settings/alertMessaging/Status')}} status</div>
                        </el-col>
                        <el-col :md="24">
                            <div class="Container">{{$l('settings/alertMessaging/GPS')}} gps</div>
                        </el-col>
                        <el-col :md="24">
                            <div class="Container">{{$l('settings/alertMessaging/Threshold change')}} threshold day/night/opt1/opt2 60 admin password</div>
                        </el-col>
                    </el-row>
                </el-collapse-item>

                <el-collapse-item v-if="$p('settings/alertMessaging/emailsett') && (getScreenSize > 1 || delayedLoading[6])" :title="$l('settings/alertMessaging/Email settings')">
                    <el-row :gutter="25">
                        <el-col v-if="$p('settings/alertMessaging/sender')" :lg="12">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Sender Email')">
                                <el-input :disabled="getSettingsAddons.email == '0'" v-model="getSettingsEmail.user"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$p('settings/alertMessaging/password')" v-show="getSettingsAddons.email == '1'" :lg="12">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/Password')">
                                <el-input :type="showPassword?'':'password'" v-model="getSettingsEmail.pwd">
                                    <el-button @click="showPassword=!showPassword" class="show-password-button" slot="append"><icon name="eye"> </icon></el-button>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$p('settings/alertMessaging/smtp')" v-show="getSettingsAddons.email == '1'" :lg="12">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/SMTP server')">
                                <el-input v-model="getSettingsEmail.smtp"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="$p('settings/alertMessaging/smtp')" v-show="getSettingsAddons.email == '1'" :lg="12">
                            <el-form-item class="el-form-item-full" :label="$l('settings/alertMessaging/SMTP port')">
                                <el-input v-model="getSettingsEmail.port"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-collapse-item>
            </el-collapse>
        </el-row>
    </el-form>
</template>

<style scoped>
.LEQContainer{
    padding-top:10px;
    padding-left:10px;
    padding-right:10px;
    border: 1px solid #e1e5ec;
}
.Container{
    padding:10px;
    border: 1px solid #e1e5ec;
    margin-top:3px;
}
.buttons{
    z-index: -1;
    margin-bottom:10px;
}
.AddEmailButton{
    margin-top:9px;
    width:100px;
}
.DeleteEmailButton{
    margin-top:4px;
    width:100px;
}

</style>

<script>
import { mapGetters } from 'vuex'
import {testEmail} from '@/store/actions'
export default {
    data() {
        return {
            selectedGroups:[],
            selectedEmail:'',
            selectedNumber:'',
            selectedDeleteRecipients:[],
            deleteGroup:'',
            deleteRecipientGroup:'',

            delayedLoading:{'0':0,'1':0,'2':0,'3':0,'4':0,'5':0,'6':0,'7':0,'8':0,'9':0,'10':0},

            newGroup: false,
            dialogVisible: false,
            dialogVisible1: false,
            visible:false,
            showPassword:false
        }
    },
    computed:{
        ...mapGetters([
            'getSettingsAlertMessaging',
            'getSettingsAddons',
            'getSettingsSpecval',
            'getSettingsEmail',
            'getScreenSize'
        ]),
    },
    methods: {
        addGroup(){
            var allAlerts = ["threshday","threshnight","threshopt1","threshopt2","threshweath","mav","reboot","n140","ftperr","n140sd","discerr","micerr","battmode","weather","weatTrig","videotrig","videoerr","leqday"];
            var id = 0;
            this.getSettingsAlertMessaging.groups.forEach(group=>{
                var gId = parseInt(group.replace('gr',''));
                if(id <= gId) id = gId+1;
            })
            var alg = {};
            allAlerts.forEach(alert=>{
                alg[alert] = true;
            })
            var del = '';
            var leqdg = [0,0];
            var recpg = [];
            this.getSettingsAlertMessaging['alg'+id] = alg;
            this.getSettingsAlertMessaging['del'+id] = del;
            this.getSettingsAlertMessaging['leqdg'+id] = leqdg;            
            this.getSettingsAlertMessaging['recpg'+id] = recpg;
            this.getSettingsAlertMessaging['repg'+id] =  ["0","0","0","0","0","0","0"];
            this.getSettingsAlertMessaging['lqtg'+id] = [true,true,true];
            this.getSettingsAlertMessaging.groups.push('gr'+id);

        },
        addRecipientClicked(){
            if (this.selectedGroups.length == 0){
                this.$message({
                    message:this.$l('settings/alertMessaging/groupsError'),
                    type:'error',
                    customClass:'error-message-one'
                    
                });
            
                return;
            }
            this.selectedGroups.forEach(group=>{
                if(this.selectedEmail){
                    var id = group.replace('gr','');
                    if(this.getSettingsAlertMessaging['recpg'+id].indexOf(this.selectedEmail) == -1)
                        this.getSettingsAlertMessaging['recpg'+id].push(this.selectedEmail);
                }
                if(this.selectedNumber){
                    var id = group.replace('gr','');
                    if(this.getSettingsAlertMessaging['recpg'+id].indexOf(this.selectedNumber) == -1)
                        this.getSettingsAlertMessaging['recpg'+id].push(this.selectedNumber);
                }
            })

            this.selectedGroups = [];
            this.selectedEmail = '';
            this.selectedNumber = '';
        },
        sendTestMail(group){
            testEmail(this,group)
                .then(()=>{
                    this.$message({
                        message: this.$l('settings/alertMessaging/emailSent'),
                        type: 'success'
                    });
                })
            
            //api/test-email&email=""
        },
        removeGroup(item){
            var index = this.getSettingsAlertMessaging.groups.indexOf(item);
            if(index > -1){
                this.getSettingsAlertMessaging.groups.splice(index,1);
                var id = item.replace('gr','');
                delete this.getSettingsAlertMessaging['alg'+id]
                delete this.getSettingsAlertMessaging['del'+id];
                delete this.getSettingsAlertMessaging['leqdg'+id];
                delete this.getSettingsAlertMessaging['recpg'+id];
                delete this.getSettingsAlertMessaging['repg'+id];
                delete this.getSettingsAlertMessaging['lqtg'+id];
            }
        },
        deleteRecipient(group){
            var id = group.replace('gr','');
            var del = this.getSettingsAlertMessaging['del'+id];
            var index = this.getSettingsAlertMessaging['recpg'+id].indexOf(del);
            if(index > -1){
                this.getSettingsAlertMessaging['recpg'+id].splice(index,1);
            }
            this.getSettingsAlertMessaging['del'+id] = '';
        }
    },
    mounted: function(){
         setTimeout(()=>{
            var counter = 0;
            var delayedLoadingInterval = setInterval(()=>{
                this.delayedLoading[counter] = true;
                counter++;
                if(counter > 6) 
                    clearInterval(delayedLoadingInterval);
            },0);
        },500)
    }
}
</script>


// WEBPACK FOOTER //
// AlertMessaging.vue?2ef296d8